export enum EFormButtonWatcherActions {
    disable = 'disable', // сделать кнопку disabled
    hide = 'hide', // скрыть кнопку
}

export enum EFormButtonWatcherConditions {
    unset = 'unset', // если target-поле имеет falsy-значение (false, undefined, null, "", 0 и т.д.)
    filterUnset = 'filterUnset', // если фильтр по withKey имеет falsy-значение (false, undefined, null, "", 0 и т.д.)
    formHasData = 'formHasData', // если форма не пустая (хотя бы в 1 поле было что-то введено)
}

export interface IFormButtonWatcherCondition {
    target?: string; // ключ поля, которое отслеживается watcher'ом
    when: EFormButtonWatcherConditions; // событие для срабатывания условия
    withValue?: string; // значение target поля, чтобы watcher сработал
    withKey?: string; // используется, если when === ("equalsToValue" или "fieldEqualsToValue")
    withConnective?: EFormButtonWatcherConnective; // принцип, по которому условие добавляется к предыдущему
    withValueAsNumber?: boolean;

}

export enum EFormButtonWatcherConnective {
    OR = 'OR',
    AND = 'AND',
    NOT = 'NOT',
    AND_NOT = 'AND_NOT',
    OR_NOT = 'OR_NOT'
}

export interface IFormButtonWatcher {
    conditions: IFormButtonWatcherCondition[]; // настройка условий, при которых срабатывает watcher
    perform: EFormButtonWatcherActions[]; // действия при срабатывании
}
